export default function emptyChoicesToNull(data, fields) {
    const entries = Object.entries(data).map(([key, value]) => {
        const isChoice = fields[key]?.meta?.options != null
        const isEmpty = value === '' || value === undefined

        return [key, isChoice && isEmpty ? null : value]
    })

    return Object.fromEntries(entries)
}
